import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { mergeDeepLeft } from "ramda";
import devDebug from "../Helpers/debug";
import dayjs from "dayjs";
import idbKeyvalAdapter from "./1_utility";


const initialState = {
  tasks: {
    tenderCreate: {},
    tenderAutoConfirm: {},
    editTenderFieldRegenerate: {},
    vademecumFieldRegenerate: {},
  },
  intervals: {
    tenderCreate: {},
    tenderAutoConfirm: {},
    editTenderFieldRegenerate: {},
    vademecumFieldRegenerate: {},
  },
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useTaskManagementStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ------------------------- TASKS -------------------------
      setTask: (
        type,
        id, //id here could be tender ID or vademecum ID
        task,
        fieldName //only used when it's a specific field on edit_tender or vademecum
      ) =>
        set((state) => {
          if (fieldName) {
            if (!state?.tasks?.[type]?.[id]) {
              state.tasks[type][id] = {};
            }
            state.tasks[type][id][fieldName] = task;
          } else {
            state.tasks[type][id] = task; //id here could be tender ID or vademecum ID
          }
        }),
      deleteTask: (
        type,
        id, //id here could be tender ID or vademecum ID
        fieldName //only used when it's a specific field on edit_tender or vademecum
      ) =>
        set((state) => {
          if (fieldName) {
            delete state.tasks[type][id][fieldName];
          } else {
            delete state.tasks[type][id]; //id here could be tender ID or vademecum ID
          }
        }),
      setTaskInterval: (
        type,
        id, //id here could be tender ID or vademecum ID
        interval,
        fieldName //only used when it's a specific field on edit_tender or vademecum
      ) =>
        set((state) => {
          devDebug("setting interval: ", interval, " with fieldName: ", fieldName, " and id: ", id, " of type: ", type);
          if (fieldName) {
            if (!state?.intervals?.[type]?.[id]) {
              state.intervals[type][id] = {};
            }
            state.intervals[type][id][fieldName] = { intervalID: interval, timestamp: dayjs() };
          } else {
            state.intervals[type][id] = { intervalID: interval, timestamp: dayjs() }; //id here could be tender ID or vademecum ID
          }
        }),
      deleteTaskInterval: (
        type,
        id, //id here could be tender ID or vademecum ID
        fieldName //only used when it's a specific field on edit_tender or vademecum
      ) =>
        set((state) => {
          if (fieldName) {
            if (state?.intervals?.[type]?.[id]?.[fieldName]) {
              delete state.intervals[type][id][fieldName]; //id here could be tender ID or vademecum ID
            }
          } else {
            if (state?.intervals?.[type]?.[id]) {
              delete state.intervals[type][id]; //id here could be tender ID or vademecum ID
            }
          }
        }),

      resetState: () => {
        useTaskManagementStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: "taskManagement",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[taskManagementStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[taskManagementStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[taskManagementStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[taskManagementStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[taskManagementStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[taskManagementStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[taskManagementStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[taskManagementStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[taskManagementStore] Error during rehydration. Store name: "taskManagementStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[taskManagementStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
